import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useContext } from "react";
import Landingpage from "./pages/landingpage";
import Success from './components/Success'; // Add this import
import Cancel from './components/Cancel'; // Add this import
// import { AppContextProvider } from "./context/AppContext";
import { AppProvider } from './context/AppContext';
import { AppProviderisChecked } from "./context/AppContextisChecked";
import { AuthContextProvider } from "./context/AuthContext";
import { ConversationProvider } from "./context/ConversationContext";
import OutreachPanel from "./components/OutreachPanel";
import LegalPanel from "./components/LegalPanel";
import "./App.css";

// The sidebar (chat history + settings) now lives inside the TopBar's single
// SlidingSlidebar drawer, so the landing page renders full-width here.
function ChatLayout() {
  return <Landingpage />;
}

function App() {
  return (
    <AuthContextProvider>
      <AppProviderisChecked>
        <AppProvider>
          <ConversationProvider>
            <Router>
              <Routes>
                <Route path="/" element={<ChatLayout />} />
                <Route path="/outreach" element={<OutreachPanel />} />
                <Route path="/legal" element={<LegalPanel />} />
                <Route path="/success" element={<Success />} />
                <Route path="/cancel" element={<Cancel />} />
              </Routes>
            </Router>
          </ConversationProvider>
        </AppProvider>
      </AppProviderisChecked>
    </AuthContextProvider>
  );
}

export default App;
